import React, { useEffect, useState } from "react";

interface MediaShareButtonProps {
  mediaName: "whatsapp" | "facebook";
  logo: string;
}
const MediaShareButton: React.FC<MediaShareButtonProps> = ({
  mediaName,
  logo,
}) => {
  const [mediaLink, setMediaLink] = useState<string>("");

  useEffect(() => {
    const currentURL = window.location.href;
    const predefinedText =
      "Checa este perfil de proveedor en Fiestr y cotiza tu próximo evento sin complicarte:";
    const encodedUrl = encodeURIComponent(currentURL);

    if (mediaName === "whatsapp") {
      const fullMessage = `${predefinedText} ${currentURL}`;
      const whatsappShareUrl = `https://wa.me/?text=${fullMessage}`;
      setMediaLink(whatsappShareUrl);
    } else if (mediaName === "facebook") {
      const encodedQuote = encodeURIComponent(predefinedText);
      const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedQuote}`;
      setMediaLink(facebookShareUrl);
    }
  }, [mediaName]);

  const handleShareClick = () => {
    if (mediaLink) {
      window.open(mediaLink, "_blank");
      return;
    }
    console.error(`${mediaName} link not generated yet.`);
  };

  return (
    <a
      href={mediaLink}
      onClick={handleShareClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      <button
        className="btn d-flex align-items-center justify-content-center social-btn"
        style={{
          width: "clamp(45px, 12vw, 52px)",
          height: "clamp(45px, 12vw, 52px)",
          background: "#F5F7FA",
          border: "1px solid #E3E6ED",
          borderRadius: "50%",
          padding: "0.75rem",
        }}
      >
        <img src={logo} />
      </button>
    </a>
  );
};

export default MediaShareButton;
